import {Link as RouterLink} from 'react-router-dom'
import Seo from './Seo'
import {GUIDES_INDEX_PATH, MARKETING_PAGES, type MarketingPage} from './seoConstants'
import {softwareApplicationSchema} from './schema'
import {CtaSection} from './seoSections'
import './SeoPage.css'

const TITLE = 'Guides & Comparisons — App Store and Google Play Screenshots | Ecranify'
const DESCRIPTION =
  'Every Ecranify guide and comparison in one place: App Store and Google Play screenshot sizes, design best practices, workflows, and honest tool comparisons.'

const GuideCardList = ({pages}: {pages: readonly MarketingPage[]}) => (
  <div className="seo-index-grid">
    {pages.map((page) => (
      <RouterLink key={page.path} to={page.path} className="seo-index-card">
        <span className="seo-index-card-title">{page.label}</span>
        <span className="seo-index-card-summary">{page.summary}</span>
        <span className="seo-index-card-more">Read →</span>
      </RouterLink>
    ))}
  </div>
)

// Hub page listing every prerendered marketing page, driven entirely by
// MARKETING_PAGES so a new guide appears here automatically. The footer links
// here instead of carrying the full list.
const GuidesIndexPage = () => {
  const guides = MARKETING_PAGES.filter((page) => page.kind === 'guide')
  const comparisons = MARKETING_PAGES.filter((page) => page.kind === 'comparison')

  return (
    <div className="seo-root" data-prerender-ready>
      <Seo
        title={TITLE}
        description={DESCRIPTION}
        canonicalPath={GUIDES_INDEX_PATH}
        jsonLd={[softwareApplicationSchema()]}
      />
      <div className="seo-grid" aria-hidden />

      <main className="seo-page">
        <header className="seo-hero">
          <span className="seo-eyebrow">
            <span className="seo-eyebrow-dot" />
            Library
          </span>
          <h1 className="seo-h1">Guides & comparisons</h1>
          <p className="seo-lede">
            Everything we have written about getting App Store and Google Play listings right — exact asset sizes,
            screenshot strategy, production workflows, and straight comparisons with the other tools in this space.
          </p>
        </header>

        <section className="seo-section">
          <h2 className="seo-h2">Guides</h2>
          <GuideCardList pages={guides} />
        </section>

        <section className="seo-section">
          <h2 className="seo-h2">Tool comparisons</h2>
          <GuideCardList pages={comparisons} />
        </section>

        <CtaSection
          cta={{
            title: 'Put any of it into practice',
            body: 'Design a 3D device mockup in your browser and export store-ready screenshots at every required size. Free to start, no signup.',
          }}
        />
      </main>
    </div>
  )
}

export default GuidesIndexPage
